<template>
  <div class="mit-analytics-chart-container">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js/auto';

export default {
  name: 'MitAnalyticsChartLine',
  props: {
    chartData: { type: Object, required: true }, // Now expects { labels: [], datasets: [] }
    title: { type: String, default: 'Trend' },
    labelX: { type: String, default: 'Date' },
    labelY: { type: String, default: 'Count' }
  },
  data() {
    return {
      chartInstance: null
    };
  },
  mounted() {
    this.renderChart();
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.renderChart();
      }
    }
  },
  methods: {
    renderChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }
      const ctx = this.$refs.chartCanvas;
      if (!ctx) return;

      this.chartInstance = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.chartData.labels,
          datasets: this.chartData.datasets // Maps directly to our new data structure
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { 
              display: true, // Enabled the legend
              position: 'bottom' 
            },
            title: { display: true, text: this.title }
          },
          scales: {
            y: { beginAtZero: true, title: { display: true, text: this.labelY } },
            x: { title: { display: true, text: this.labelX } }
          }
        }
      });
    }
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  }
};
</script>

<style scoped>
.mit-analytics-chart-container {
  position: relative;
  height: 300px;
  width: 100%;
}
</style>